import type { NutritionLineType, ProductNutrition } from "../types/productTypes";

export const isProductNutrition = (nutrition: NutritionLineType[] | ProductNutrition[]): nutrition is ProductNutrition[] => {
   return nutrition.length > 0 && "productName" in nutrition[0];
};
